/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Button from '../../components/task/shop/form/button';
import {getDepartments, getDepartmentsConfig} from "../../store/dispo/selectors";
import {getTasksCurrent} from "../../store/tasks/selectors";
import * as R from 'ramda';

const ListWrapper = styled.div`
    
`

const ListHeader = styled.div`
    
`

const WrapperWrapper = styled.div`
	background: #fff;
	padding: 13px 19px;
	border-radius: 8px;
	border: 1px solid #d9d7d7;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
`;

const List = styled.ul`
	flex: 0 1 ${({width}) => width ? width : '100%'};
	list-style: none outside;
	overflow: auto;
	border-bottom: 1px solid #d9d7d7;
	${({isreport}) => isreport ? 'max-height: 250px;' : 'max-height: 400px;'}
`;

const ListItem = styled.li`
	font-size: 19px;
	color: ${({selected}) => selected ? '#43abf3' : '#3b3b3b'};
	padding-bottom: 15px;
	cursor: pointer;

	& + li {
		padding-top: 25px;;
		border-top: 1px solid #95989a;
	}
`;

class DepartmentsInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItems: {},
        };
    }

    setSelected = function (configs, index) {
        const {handleSelect, departments} = this.props;
        let selectedItems = {};
        selectedItems[index] = true;
        this.setState({selectedItems});

        handleSelect({value: configs, viewValue: R.map(config => {
                return R.find(R.propEq('id', config), departments).name;
            }, configs)});
    };

    isSelected = function (index) {
        const {selectedItems} = this.state;
        return selectedItems[index] ? selectedItems[index] : false;
    };

    getString = function (configs) {
        const {departments} = this.props;
        return R.join(', ',
            R.map(config => {
                const value = R.find(R.propEq('id', config), departments);
                return value ? value.name : 'N/A';
            }, configs)
        );
    };

    render() {
        const {departmentsConfig, departments, handleComplete, data} = this.props;
        const {selectedItems} = this.state;
        return (
            <WrapperWrapper>
                <List key={`dep-config-list`}>
                    {departmentsConfig && departmentsConfig.map((configs, index) =>
                        (<ListItem key={`dep-config-item-${index}`}
                                   selected={this.isSelected(index)}
                                   className={`${this.isSelected(index) ? 'selected' : ''}`}
                                   onClick={() => this.setSelected(configs, index)}>
                                <span>{this.getString(configs)}</span>
                            </ListItem>
                        ))}
                </List>

                <Button handleClick={() => handleComplete({...data, selectedItems, departmentsConfig, departments})}
                        width="100%"/>
            </WrapperWrapper>
        )
    };
};

export default connect(
    (state) => ({
        departments: getDepartments(state),
        currentTask: getTasksCurrent(state),
        departmentsConfig: getDepartmentsConfig(state),
    })
)(DepartmentsInput);



// WEBPACK FOOTER //
// ./src/containers/disponent/departmentsConfig-input.js